import { useState, useEffect, useRef, useMemo } from "react";
import ExcelJS from "exceljs";
import {
    GetAllProduct,
    AddProduct,
    UpdateProduct,
    RemoveProduct,
} from "../services/ProductService";
import { useLanguage } from "./LanguageContext"; // مسیر واقعی خودت

/*
 * مقادیر enum زیر دقیقاً مطابق
 * Ordering.DataLayout.Enum.Product.PackingTypeEnum سمت بک‌اند است:
 * Shrink = 1, Carton = 2
 */
const PACKING_TYPE_OPTIONS = [
    { value: 1, fa: "شیرینگ", ar: "شرينك" },
    { value: 2, fa: "کارتن", ar: "كرتون" },
    { value: 0, fa: "عدد", ar: "رقم" },
];

const TEXTS = {
    fa: {
        dir: "rtl",
        products: "محصولات",
        manageSub: "مدیریت لیست محصولات — افزودن، ویرایش و حذف",
        newProduct: "محصول جدید",
        searchPlaceholder: "جستجوی محصول...",
        listView: "فهرست",
        gridView: "کارت",
        loadError: "خطا در دریافت لیست محصولات. لطفاً دوباره تلاش کنید.",
        somethingWrong: "مشکلی پیش آمد",
        retry: "تلاش دوباره",
        noResult: "نتیجه‌ای یافت نشد",
        noProductYet: "هنوز محصولی ثبت نشده",
        searchOther: "با عبارت دیگری جستجو کنید.",
        addFirstProduct: "با دکمه «محصول جدید» اولین محصول را اضافه کنید.",
        code: "کد",
        productName: "نام محصول",
        packingType: "نوع بسته‌بندی",
        countOfBox: "تعداد در بسته",
        actions: "عملیات",
        edit: "ویرایش",
        delete: "حذف",
        productCountLabel: "محصول",
        editProduct: "ویرایش محصول",
        addNewProduct: "افزودن محصول جدید",
        editNameSub: "اطلاعات محصول را ویرایش کنید",
        enterNewNameSub: "اطلاعات محصول جدید را وارد کنید",
        productCodeLabel: "کد محصول",
        productCodePlaceholder: "",
        productNameLabel: "نام محصول",
        namePlaceholder: "",
        packingTypeLabel: "نوع بسته‌بندی",
        countOfBoxLabel: "تعداد در بسته",
        countOfBoxPlaceholder: "",
        cancel: "انصراف",
        saving: "در حال ذخیره...",
        saveChanges: "ذخیره تغییرات",
        add: "افزودن",
        deleteProductTitle: "حذف محصول",
        deleteConfirm: "آیا از حذف «{name}» مطمئن هستید؟ این عملیات قابل بازگشت نیست.",
        // پیام جدید: زمانی که محصول در جدول گروپینگ زیرمجموعه فعال دارد
        deleteWithChildrenConfirm:
            "«{name}» در گروه‌بندی محصولات دارای زیرمجموعه فعال است. با ادامه، آن گروه‌بندی و تمام زیرمجموعه‌هایش نیز حذف خواهند شد. آیا مطمئن هستید؟",
        deleting: "در حال حذف...",
        deleteIt: "حذف کن",
        deleteAnyway: "بله، همه را حذف کن",
        productEdited: "محصول با موفقیت ویرایش شد.",
        productAdded: "محصول با موفقیت افزوده شد.",
        saveFailed: "ذخیره‌سازی با خطا مواجه شد. دوباره تلاش کنید.",
        productDeleted: "محصول حذف شد.",
        deleteFailed: "حذف محصول با خطا مواجه شد.",
        requiredField: "این فیلد الزامی است.",
        greaterThanZero: "مقدار باید بزرگتر از صفر باشد.",
        duplicateCodeError: "این کد محصول قبلاً برای محصول دیگری ثبت شده است.",
        weight: "وزن",
        weightLabel: "وزن هر عدد",
        weightPlaceholder: "",
        weightUnit: "گرم",
        exportExcel: "خروجی اکسل",
        importExcel: "ورودی اکسل",
        exportingExcel: "در حال ساخت فایل...",
        importingExcel: "در حال وارد کردن...",
        importSuccess: "{count} محصول با موفقیت اضافه شد.",
        importPartial: "{success} محصول اضافه شد، {fail} مورد اضافه نشد:",
        importFailed: "وارد کردن اکسل با خطا مواجه شد.",
        importEmptyFile: "فایل اکسل خالی است یا ساختار آن نامعتبر است.",
        importDuplicateRow: "«{name}» به دلیل داشتن کد محصول تکراری اضافه نشد.",
        importGenericRowFail: "«{name}» اضافه نشد. ({reason})",
        importAllFailedDuplicate: "هیچ محصولی اضافه نشد. همهٔ {fail} مورد به دلیل کد محصول تکراری رد شدند:",
        noDataToExport: "محصولی برای خروجی گرفتن وجود ندارد.",
        importModalTitle: "ورود اطلاعات از اکسل",
        importModalDesc: "ابتدا فایل نمونه را دانلود کنید، آن را با اطلاعات محصولات خود تکمیل کنید، سپس همان فایل را بارگذاری و وارد کنید.",
        downloadSampleTitle: "۱. دانلود فایل نمونه",
        downloadSampleDesc: "فایل نمونه فقط شامل ستون‌های موردنیاز است، بدون هیچ داده‌ای.",
        downloadSampleBtn: "دانلود فایل نمونه",
        downloadingSample: "در حال ساخت فایل نمونه...",
        uploadFileTitle: "۲. بارگذاری فایل تکمیل‌شده",
        uploadFileDesc: "فایل اکسل خود را انتخاب کنید تا اطلاعات آن بررسی و وارد شود.",
        chooseFileBtn: "انتخاب فایل",
        changeFileBtn: "تغییر فایل",
        noFileChosen: "فایلی انتخاب نشده است",
        startImportBtn: "شروع ورود اطلاعات",
        sampleFileName: "نمونه-محصولات",
        importInvalidWeight: "«{name}» به دلیل نداشتن وزن معتبر (صفر یا خالی) اضافه نشد.",
        // وضعیت فعال/غیرفعال محصول
        status: "وضعیت",
        active: "فعال",
        inactive: "غیرفعال",
        allStatus: "همه",
        isActiveLabel: "محصول فعال است",
        isActiveHint: "محصولات غیرفعال در فروش و سفارش‌گیری نمایش داده نمی‌شوند.",
        activate: "فعال‌سازی",
        deactivate: "غیرفعال‌سازی",
        productActivated: "محصول فعال شد.",
        productDeactivated: "محصول غیرفعال شد.",
        statusChangeFailed: "تغییر وضعیت محصول با خطا مواجه شد.",
        noResultStatus: "با این فیلتر وضعیت، محصولی یافت نشد.",
    },
    ar: {
        dir: "rtl",
        products: "المنتجات",
        manageSub: "إدارة قائمة المنتجات — إضافة، تعديل وحذف",
        newProduct: "منتج جديد",
        searchPlaceholder: "البحث عن منتج...",
        listView: "قائمة",
        gridView: "بطاقات",
        loadError: "خطأ في جلب قائمة المنتجات. حاول مرة أخرى.",
        somethingWrong: "حدث خطأ",
        retry: "إعادة المحاولة",
        noResult: "لا توجد نتائج",
        noProductYet: "لا يوجد منتج بعد",
        searchOther: "حاول البحث بكلمة أخرى.",
        addFirstProduct: "أضف أول منتج باستخدام زر «منتج جديد».",
        code: "الرمز",
        productName: "اسم المنتج",
        packingType: "نوع التعبئة",
        countOfBox: "العدد في العبوة",
        actions: "العمليات",
        edit: "تعديل",
        delete: "حذف",
        productCountLabel: "منتج",
        editProduct: "تعديل المنتج",
        addNewProduct: "إضافة منتج جديد",
        editNameSub: "عدّل بيانات المنتج",
        enterNewNameSub: "أدخل بيانات المنتج الجديد",
        productCodeLabel: "رمز المنتج",
        productCodePlaceholder: "",
        productNameLabel: "اسم المنتج",
        namePlaceholder: "",
        packingTypeLabel: "نوع التعبئة",
        countOfBoxLabel: "العدد في العبوة",
        countOfBoxPlaceholder: "",
        cancel: "إلغاء",
        saving: "جارٍ الحفظ...",
        saveChanges: "حفظ التغييرات",
        add: "إضافة",
        deleteProductTitle: "حذف المنتج",
        deleteConfirm: "هل أنت متأكد من حذف «{name}»؟ هذا الإجراء غير قابل للتراجع.",
        // رسالة جديدة: عندما يحتوي المنتج على مجموعات فرعية نشطة
        deleteWithChildrenConfirm:
            "«{name}» لديه مجموعات فرعية نشطة في جدول التجميع. بالمتابعة سيتم حذف تلك المجموعة وكل مجموعاتها الفرعية أيضاً. هل أنت متأكد؟",
        deleting: "جارٍ الحذف...",
        deleteIt: "حذف",
        deleteAnyway: "نعم، احذف الكل",
        productEdited: "تم تعديل المنتج بنجاح.",
        productAdded: "تمت إضافة المنتج بنجاح.",
        saveFailed: "فشل الحفظ. حاول مرة أخرى.",
        productDeleted: "تم حذف المنتج.",
        deleteFailed: "فشل حذف المنتج.",
        requiredField: "هذا الحقل مطلوب.",
        greaterThanZero: "يجب أن تكون القيمة أكبر من صفر.",
        duplicateCodeError: "رمز المنتج هذا مُسجَّل بالفعل لمنتج آخر.",
        weight: "الوزن",
        weightLabel: "وزن الوحدة",
        weightPlaceholder: "",
        weightUnit: "غرام",
        exportExcel: "تصدير Excel",
        importExcel: "استيراد Excel",
        exportingExcel: "جارٍ إنشاء الملف...",
        importingExcel: "جارٍ الاستيراد...",
        importSuccess: "تمت إضافة {count} منتج بنجاح.",
        importPartial: "تمت إضافة {success} منتج، ولم تتم إضافة {fail}:",
        importFailed: "فشل استيراد ملف Excel.",
        importEmptyFile: "الملف فارغ أو غير صالح.",
        importDuplicateRow: "لم تتم إضافة «{name}» لأن رمز المنتج مكرر.",
        importGenericRowFail: "لم تتم إضافة «{name}». ({reason})",
        importAllFailedDuplicate: "لم تتم إضافة أي منتج. كل الـ{fail} مورد تم رفضها لأن رموزها مكررة:",
        noDataToExport: "لا توجد منتجات لتصديرها.",
        importModalTitle: "استيراد البيانات من Excel",
        importModalDesc: "قم أولاً بتنزيل الملف النموذجي، واملأه ببيانات منتجاتك، ثم قم برفع نفس الملف واستيراده.",
        downloadSampleTitle: "١. تنزيل الملف النموذجي",
        downloadSampleDesc: "يحتوي الملف النموذجي على الأعمدة المطلوبة فقط، بدون أي بيانات.",
        downloadSampleBtn: "تنزيل الملف النموذجي",
        downloadingSample: "جارٍ إنشاء الملف النموذجي...",
        uploadFileTitle: "٢. رفع الملف المكتمل",
        uploadFileDesc: "اختر ملف Excel الخاص بك ليتم فحص بياناته واستيرادها.",
        chooseFileBtn: "اختيار ملف",
        changeFileBtn: "تغيير الملف",
        noFileChosen: "لم يتم اختيار أي ملف",
        startImportBtn: "بدء الاستيراد",
        sampleFileName: "نموذج-المنتجات",
        importInvalidWeight: "لم تتم إضافة «{name}» لعدم وجود وزن صالح (صفر أو فارغ).",
        // حالة تفعيل/تعطيل المنتج
        status: "الحالة",
        active: "مفعّل",
        inactive: "معطّل",
        allStatus: "الكل",
        isActiveLabel: "المنتج مفعّل",
        isActiveHint: "المنتجات المعطّلة لا تظهر في المبيعات وتسجيل الطلبات.",
        activate: "تفعيل",
        deactivate: "تعطيل",
        productActivated: "تم تفعيل المنتج.",
        productDeactivated: "تم تعطيل المنتج.",
        statusChangeFailed: "فشل تغيير حالة المنتج.",
        noResultStatus: "لا توجد منتجات مطابقة لفلتر الحالة.",
    },
};

const COLORS = {
    bg: "#F4F2FB",
    paper: "#FBFAFD",
    card: "#FFFFFF",
    ink: "#221D3A",
    inkSoft: "#5B5578",
    muted: "#9C97B3",
    hairline: "#E8E4F3",
    hairlineStrong: "#D9D2ED",

    // primary accent (matches the reference purple gradient theme)
    accent: "#7C3AED",
    accentDeep: "#5B21B6",
    accentBg: "#EFE6FC",
    accentBgSoft: "#F6F0FD",

    gradientFrom: "#6D28D9",
    gradientVia: "#7C3AED",
    gradientTo: "#9333EA",
    gradientText: "#EFE3FE",

    success: "#3D7A5C",
    successBg: "#E5F1EA",
    danger: "#AE3B26",
    dangerBg: "#FBEAE4",
    dangerBorder: "#EFCBBA",

    // رنگ هشدار برای حالت "دارای زیرمجموعه"
    warning: "#946200",
    warningBg: "#FBF1DC",
    warningBorder: "#EFD9A4",
};

const FONT_DISPLAY = "IRANSansWeb, 'Segoe UI', Tahoma, sans-serif";
const FONT_BODY = "IRANSansWeb, 'Segoe UI', Tahoma, sans-serif";
const FONT_MONO = "IRANSansWeb, 'Segoe UI', Tahoma, sans-serif";

function FontLoader() {
    return (
        <style>{`
            @keyframes pp-fade-in { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
            @keyframes pp-pop-in { from { opacity: 0; transform: scale(0.96) translateY(8px); } to { opacity: 1; transform: scale(1) translateY(0); } }
            @keyframes pp-toast-in { from { opacity: 0; transform: translate(-50%, -12px); } to { opacity: 1; transform: translate(-50%, 0); } }
            .pp-row { transition: background 0.12s ease; }
            .pp-tile { transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease; }
            .pp-tile:hover { transform: translateY(-3px); border-color: ${COLORS.hairlineStrong}; box-shadow: 0 10px 24px rgba(34,29,58,0.08); }
            .pp-icon-btn { transition: background 0.12s ease, border-color 0.12s ease, transform 0.1s ease; }
            .pp-icon-btn:active { transform: scale(0.92); }
            .pp-btn-primary { transition: background 0.12s ease, transform 0.1s ease; }
            .pp-btn-primary:hover { background: ${COLORS.accentDeep}; }
            .pp-btn-primary:active { transform: scale(0.97); }
            .pp-header-btn { transition: background 0.12s ease, transform 0.1s ease; }
            .pp-header-btn:hover { background: rgba(255,255,255,0.28); }
            .pp-header-btn:active { transform: scale(0.97); }
            .pp-toggle-btn { transition: background 0.15s ease, color 0.15s ease; }
            .pp-input:focus { border-color: ${COLORS.accent} !important; box-shadow: 0 0 0 3px ${COLORS.accentBg}; }
            .pp-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
            .pp-scrollbar::-webkit-scrollbar-thumb { background: ${COLORS.hairlineStrong}; border-radius: 3px; }
            .pp-tree-leaf:hover { background: ${COLORS.accentBgSoft}; }
            .pp-sort-header:hover { color: ${COLORS.ink} !important; }

            /* ---- Responsive tweaks for mobile ---- */
            .pp-header-box { padding: 30px 34px; }
            .pp-header-actions { gap: 8px; }
            .pp-header-btn { padding: 10px 16px; font-size: 12.5px; }
            .pp-header-btn .pp-header-btn-label { display: inline; }
            .pp-search-box { margin: -22px 28px 22px; padding: 16px 22px; }
            .pp-content-box { margin: 0 28px; }
            .pp-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }

            @media (max-width: 640px) {
                .pp-header-box { padding: 20px 16px; }
                .pp-header-actions { gap: 6px; width: 100%; }
                .pp-header-btn {
                    padding: 7px 9px !important;
                    font-size: 10.5px !important;
                    border-radius: 8px !important;
                    gap: 4px !important;
                    flex: 1 1 auto;
                    justify-content: center;
                }
                .pp-header-btn .pp-header-btn-icon { font-size: 11px !important; }
                .pp-search-box { margin: -16px 12px 16px !important; padding: 12px 14px !important; }
                .pp-content-box { margin: 0 12px !important; }
                .pp-table-wrap { min-width: 0 !important; }
            }
        `}</style>
    );
}

/*
 * آیکون‌های SVG دست‌ساز (بدون هیچ وابستگی به URL خارجی).
 * برای دکمه‌ی فعال/غیرفعال‌سازی: وقتی محصول فعال است، آیکون «توقف/غیرفعال‌سازی»
 * نمایش داده می‌شود و وقتی غیرفعال است، آیکون «تیک/فعال‌سازی».
 */
function ToggleActiveIcon({ isActive, size = 14 }) {
    return isActive ? (
        // محصول فعال است → کلیک = غیرفعال‌سازی
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="8.4" stroke="currentColor" strokeWidth="1.8" />
            <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
    ) : (
        // محصول غیرفعال است → کلیک = فعال‌سازی
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="8.4" stroke="currentColor" strokeWidth="1.8" />
            <path d="M7.8 12.4l2.7 2.7L16.4 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function ChevronIcon({ dir = "start", size = 13 }) {
    // dir: "start" = فلش رو به آغاز (صفحه قبل), "end" = فلش رو به پایان (صفحه بعد)
    const d = dir === "start" ? "M14.5 6l-6 6 6 6" : "M9.5 6l6 6-6 6";
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d={d} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function ChevronsIcon({ dir = "start", size = 13 }) {
    const d = dir === "start"
        ? "M17.5 6l-6 6 6 6M10.5 6l-6 6 6 6"
        : "M6.5 6l6 6-6 6M13.5 6l6 6-6 6";
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d={d} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

/* نوار صفحه‌بندی شیک با شماره صفحات، دکمه اول/آخر و انتخاب تعداد در هر صفحه */
function Pagination({ page, totalPages, totalItems, pageSize, onPageChange, onPageSizeChange, t, lang }) {
    if (totalItems === 0) return null;

    const from = totalItems === 0 ? 0 : (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, totalItems);

    // ساخت لیست شماره صفحات با «...» برای فاصله‌های بزرگ
    const pages = [];
    const windowSize = 1;
    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || Math.abs(i - page) <= windowSize) {
            pages.push(i);
        } else if (pages[pages.length - 1] !== "...") {
            pages.push("...");
        }
    }

    const btnBase = {
        minWidth: 30, height: 30, borderRadius: 9,
        border: `1.5px solid ${COLORS.hairline}`,
        background: "#fff", cursor: "pointer", fontFamily: FONT_MONO,
        fontSize: 11.5, fontWeight: 700, color: COLORS.inkSoft,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "0 4px",
    };

    return (
        <div className="pp-pagination" style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            gap: 12, flexWrap: "wrap",
            padding: "12px 18px", marginTop: 12,
            background: COLORS.card, borderRadius: 14, border: `1px solid ${COLORS.hairline}`,
            flexShrink: 0,
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 11, color: COLORS.muted }}>
                <span style={{ fontFamily: FONT_MONO }}>
                    {from}–{to} {lang === "ar" ? "من" : "از"} {totalItems} {t.productCountLabel}
                </span>
                <select
                    value={pageSize}
                    onChange={e => onPageSizeChange(Number(e.target.value))}
                    className="pp-input"
                    title={lang === "ar" ? "عدد الصفوف في الصفحة" : "تعداد ردیف در هر صفحه"}
                    style={{
                        border: `1.5px solid ${COLORS.hairline}`, borderRadius: 8,
                        fontFamily: FONT_MONO, fontSize: 11, color: COLORS.inkSoft,
                        background: COLORS.paper, padding: "4px 8px", cursor: "pointer", outline: "none",
                    }}
                >
                    {[10, 20, 50, 100].map(n => (
                        <option key={n} value={n}>
                            {n} {lang === "ar" ? "/ صفحة" : "در صفحه"}
                        </option>
                    ))}
                </select>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <button
                    className="pp-icon-btn"
                    style={{ ...btnBase, opacity: page === 1 ? 0.45 : 1, cursor: page === 1 ? "default" : "pointer" }}
                    disabled={page === 1}
                    onClick={() => onPageChange(1)}
                    title={lang === "ar" ? "الأولى" : "اول"}
                ><ChevronsIcon dir="start" /></button>

                <button
                    className="pp-icon-btn"
                    style={{ ...btnBase, opacity: page === 1 ? 0.45 : 1, cursor: page === 1 ? "default" : "pointer" }}
                    disabled={page === 1}
                    onClick={() => onPageChange(page - 1)}
                    title={lang === "ar" ? "السابق" : "قبلی"}
                ><ChevronIcon dir="start" /></button>

                {pages.map((p, i) => p === "..." ? (
                    <span key={`dots-${i}`} style={{ padding: "0 4px", color: COLORS.muted, fontSize: 12 }}>…</span>
                ) : (
                    <button
                        key={p}
                        onClick={() => onPageChange(p)}
                        className="pp-icon-btn"
                        style={{
                            ...btnBase,
                            border: `1.5px solid ${p === page ? COLORS.accent : COLORS.hairline}`,
                            background: p === page ? COLORS.accent : "#fff",
                            color: p === page ? "#fff" : COLORS.inkSoft,
                        }}
                    >{p}</button>
                ))}

                <button
                    className="pp-icon-btn"
                    style={{ ...btnBase, opacity: page === totalPages ? 0.45 : 1, cursor: page === totalPages ? "default" : "pointer" }}
                    disabled={page === totalPages}
                    onClick={() => onPageChange(page + 1)}
                    title={lang === "ar" ? "التالي" : "بعدی"}
                ><ChevronIcon dir="end" /></button>

                <button
                    className="pp-icon-btn"
                    style={{ ...btnBase, opacity: page === totalPages ? 0.45 : 1, cursor: page === totalPages ? "default" : "pointer" }}
                    disabled={page === totalPages}
                    onClick={() => onPageChange(totalPages)}
                    title={lang === "ar" ? "الأخيرة" : "آخر"}
                ><ChevronsIcon dir="end" /></button>
            </div>
        </div>
    );
}

function TagStamp({ index, size = 24 }) {
    const label = String(index + 1).padStart(2, "0");
    return (
        <div style={{
            width: size, height: size, flexShrink: 0,
            border: `1.5px solid ${COLORS.hairlineStrong}`,
            borderRadius: 6,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: FONT_MONO, fontSize: size * 0.36, fontWeight: 600,
            color: COLORS.inkSoft, background: COLORS.paper,
            transform: "rotate(-3deg)",
            letterSpacing: "-0.02em",
        }}>
            {label}
        </div>
    );
}

function Toast({ toast, onClose }) {
    useEffect(() => {
        if (!toast) return;
        // duration === null یعنی این toast خودش بسته نمی‌شود و فقط با کلیک
        // کاربر روی دکمه ✕ بسته می‌شود (برای پیام‌های خطای مهم/چندخطی).
        if (toast.duration === null) return;
        const timeout = toast.duration ?? 2800;
        const timer = setTimeout(onClose, timeout);
        return () => clearTimeout(timer);
    }, [toast, onClose]);

    if (!toast) return null;

    const palette = toast.type === "error"
        ? { bg: COLORS.dangerBg, border: COLORS.dangerBorder, color: COLORS.danger, icon: "!" }
        : toast.type === "warning"
            ? { bg: COLORS.warningBg, border: COLORS.warningBorder, color: COLORS.warning, icon: "⚠" }
            : { bg: COLORS.successBg, border: "#BFE0CC", color: COLORS.success, icon: "✓" };

    const dismissible = toast.duration === null;

    return (
        <div style={{
            position: "fixed", top: 20, left: "50%",
            background: palette.bg,
            border: `1.5px solid ${palette.border}`,
            color: palette.color,
            padding: "11px 18px", borderRadius: 12, fontSize: 12, fontWeight: 600,
            fontFamily: FONT_BODY,
            boxShadow: "0 10px 30px rgba(34,29,58,0.14)", zIndex: 700,
            display: "flex", alignItems: "flex-start", gap: 9,
            animation: "pp-toast-in 0.25s ease",
            maxWidth: "min(640px, 92vw)", lineHeight: 1.8,
            whiteSpace: "pre-line",
        }}>
            <span style={{
                width: 16, height: 16, borderRadius: "50%", flexShrink: 0, marginTop: 2,
                background: palette.color,
                color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 10, fontWeight: 700,
            }}>
                {palette.icon}
            </span>
            <span style={{ flex: 1 }}>{toast.message}</span>
            {dismissible && (
                <button
                    onClick={onClose}
                    className="pp-icon-btn"
                    style={{
                        width: 18, height: 18, borderRadius: 6, border: "none",
                        background: "transparent", color: palette.color,
                        cursor: "pointer", fontSize: 11, fontWeight: 700,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0, marginInlineStart: 2, opacity: 0.75,
                    }}
                >
                    ✕
                </button>
            )}
        </div>
    );
}

/*
 * ConfirmDialog حالا پراپ needsForceConfirm را می‌گیرد:
 * - false  => حالت عادی حذف (پیام و ظاهر قرمز رنگ)
 * - true   => محصول در جدول Grouping زیرمجموعه فعال دارد؛ پیام و ظاهر هشدار (زرد/نارنجی) نمایش داده می‌شود
 */
function ConfirmDialog({ open, productName, onCancel, onConfirm, loading, needsForceConfirm, t }) {
    if (!open) return null;

    const confirmText = needsForceConfirm
        ? t.deleteWithChildrenConfirm.replace("{name}", productName)
        : t.deleteConfirm.replace("{name}", productName);

    const accentColor = needsForceConfirm ? COLORS.warning : COLORS.danger;
    const accentBg = needsForceConfirm ? COLORS.warningBg : COLORS.dangerBg;

    return (
        <div style={{
            position: "fixed", inset: 0, background: "rgba(34,29,58,0.4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 600, padding: 20,
        }} onClick={onCancel}>
            <div onClick={e => e.stopPropagation()} style={{
                background: COLORS.card, borderRadius: 16, padding: 26,
                width: "100%", maxWidth: 380, boxShadow: "0 24px 60px rgba(34,29,58,0.22)",
                fontFamily: FONT_BODY, animation: "pp-pop-in 0.18s ease",
                borderTop: `4px solid ${accentColor}`,
            }}>
                <div style={{
                    width: 36, height: 36, borderRadius: 9, background: accentBg,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    marginBottom: 12, color: accentColor, fontSize: 16, fontWeight: 700,
                }}>
                    {needsForceConfirm ? "⚠" : "✕"}
                </div>
                <div style={{
                    fontSize: 15.5, fontWeight: 700, color: COLORS.ink, marginBottom: 7,
                    fontFamily: FONT_DISPLAY,
                }}>
                    {t.deleteProductTitle}
                </div>
                <div style={{ fontSize: 12.5, color: COLORS.inkSoft, lineHeight: 1.8, marginBottom: 22 }}>
                    {confirmText}
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                    <button onClick={onCancel} disabled={loading} style={{
                        flex: 1, padding: "10px 0", borderRadius: 10, border: `1.5px solid ${COLORS.hairlineStrong}`,
                        background: "#fff", color: COLORS.ink, fontWeight: 600, fontSize: 12.5,
                        cursor: loading ? "default" : "pointer", fontFamily: "inherit",
                    }}>
                        {t.cancel}
                    </button>
                    <button onClick={onConfirm} disabled={loading} style={{
                        flex: 1, padding: "10px 0", borderRadius: 10, border: "none",
                        background: accentColor, color: "#fff", fontWeight: 700, fontSize: 12.5,
                        cursor: loading ? "default" : "pointer", fontFamily: "inherit",
                        opacity: loading ? 0.7 : 1,
                    }}>
                        {loading ? t.deleting : (needsForceConfirm ? t.deleteAnyway : t.deleteIt)}
                    </button>
                </div>
            </div>
        </div>
    );
}

function FieldLabel({ children }) {
    return (
        <label style={{
            fontSize: 11, fontWeight: 600, color: COLORS.inkSoft, marginBottom: 7,
            display: "block", textTransform: "uppercase", letterSpacing: "0.04em",
        }}>
            {children}
        </label>
    );
}

/*
 * متن قرمز کوچک زیر یک فیلد فرم که وقتی آن فیلد نامعتبر است (خالی است یا
 * تکراری است) نمایش داده می‌شود.
 */
function FieldError({ message }) {
    if (!message) return null;
    return (
        <div style={{
            fontSize: 10.5, color: COLORS.danger, marginTop: 5, fontWeight: 600,
            display: "flex", alignItems: "center", gap: 4,
        }}>
            <span style={{ fontSize: 10 }}>!</span>
            {message}
        </div>
    );
}

/*
 * تابع کمکی: پیام خطای واقعی برگردانده‌شده از سرویس (مثلاً
 * "کد محصول قبلاً ثبت شده است.") را از پاسخ اکسیوس استخراج می‌کند.
 * اگر پاسخ ساختار مشخصی نداشت، پیام پیش‌فرض (fallback) را برمی‌گرداند.
 */
function getServerErrorMessage(err, fallback) {
    const data = err?.response?.data;
    if (!data) return fallback;
    if (typeof data === "string" && data.trim()) return data;
    return data.message || data.title || data.error || fallback;
}

function ProductModal({ open, mode, initialValues, onClose, onSubmit, loading, error, lang, t, productsList, excludeId }) {
    const [form, setForm] = useState({
        productCode: "",
        name: "",
        packingType: PACKING_TYPE_OPTIONS[0]?.value ?? 1,
        countOfBox: "",
        weight: "",
        isActive: true,
    });
    const [fieldErrors, setFieldErrors] = useState({});
    // فوکس اولیه روی «کد محصول» می‌رود، نه «نام محصول»
    const codeInputRef = useRef(null);

    useEffect(() => {
        if (open) {
            setForm({
                productCode: initialValues?.productCode ?? "",
                name: initialValues?.name ?? "",
                packingType: initialValues?.packingType ?? (PACKING_TYPE_OPTIONS[0]?.value ?? 1),
                countOfBox: initialValues?.countOfBox ?? "",
                weight: initialValues?.weight ?? "",
                // محصول جدید به‌صورت پیش‌فرض فعال است؛ در ویرایش، وضعیت فعلی محصول حفظ می‌شود
                isActive: initialValues ? !!initialValues.isActive : true,
            });
            setFieldErrors({});
            setTimeout(() => codeInputRef.current?.focus(), 50);
        }
    }, [open, initialValues]);

    if (!open) return null;

    const isEdit = mode === "edit";

    const updateField = (key, value) => {
        setForm(prev => ({ ...prev, [key]: value }));
        // به‌محض تایپ دوباره، خطای همان فیلد پاک می‌شود تا فرم زنده‌تر باشد
        setFieldErrors(prev => (prev[key] ? { ...prev, [key]: undefined } : prev));
    };

    const validate = () => {
        const errs = {};
        const codeTrimmed = form.productCode.trim();

        if (!codeTrimmed) {
            errs.productCode = t.requiredField;
        } else {
            // چک سمت کلاینت: آیا این کد محصول قبلاً برای محصول دیگری ثبت شده؟
            // (لیست کامل محصولات از قبل در صفحه لود شده، پس نیازی به رفتن به سرور نیست)
            const codeNormalized = codeTrimmed.toLowerCase();
            const isDuplicate = (productsList ?? []).some(p =>
                (p.productCode ?? "").trim().toLowerCase() === codeNormalized &&
                p.id !== excludeId
            );
            if (isDuplicate) errs.productCode = t.duplicateCodeError;
        }

        if (!form.name.trim()) errs.name = t.requiredField;

        // تعداد در بسته: نباید خالی، منفی یا صفر باشد
        if (form.countOfBox === "") {
            errs.countOfBox = t.requiredField;
        } else if (Number(form.countOfBox) <= 0) {
            errs.countOfBox = t.greaterThanZero;
        }

        if (form.weight === "" || Number(form.weight) <= 0)
            errs.weight = t.requiredField;
        setFieldErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        onSubmit({
            productCode: form.productCode.trim(),
            name: form.name.trim(),
            packingType: Number(form.packingType),
            countOfBox: Number(form.countOfBox),
            weight: Number(form.weight),
            isActive: !!form.isActive,
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") handleSubmit();
        if (e.key === "Escape") onClose();
    };

    const inputStyle = (hasError) => ({
        width: "100%", padding: "11px 12px", borderRadius: 10,
        border: `1.5px solid ${hasError ? COLORS.dangerBorder : COLORS.hairline}`,
        fontSize: 12.5, fontFamily: "inherit", color: COLORS.ink,
        outline: "none", background: COLORS.paper, boxSizing: "border-box",
    });

    return (
        <div style={{
            position: "fixed", inset: 0, background: "rgba(34,29,58,0.4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 600, padding: 20, overflowY: "auto",
        }}>
            {/* Backdrop click no longer closes the modal on purpose — only the
                explicit close button, Cancel, or Escape do. */}
            <div onClick={e => e.stopPropagation()} style={{
                background: COLORS.card, borderRadius: 18, padding: 28,
                width: "100%", maxWidth: 440, boxShadow: "0 24px 60px rgba(34,29,58,0.22)",
                fontFamily: FONT_BODY, animation: "pp-pop-in 0.18s ease",
                borderTop: `4px solid ${COLORS.accent}`,
            }} onKeyDown={handleKeyDown}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 20 }}>
                    <div>
                        <div style={{
                            fontSize: 16.5, fontWeight: 700, color: COLORS.ink,
                            fontFamily: FONT_DISPLAY,
                        }}>
                            {isEdit ? t.editProduct : t.addNewProduct}
                        </div>
                        <div style={{ fontSize: 11.5, color: COLORS.muted, marginTop: 3 }}>
                            {isEdit ? t.editNameSub : t.enterNewNameSub}
                        </div>
                    </div>
                    <button onClick={onClose} style={{
                        width: 28, height: 28, borderRadius: 8, border: "none",
                        background: COLORS.paper, color: COLORS.muted, fontSize: 12,
                        cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0,
                    }}>✕</button>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: error ? 10 : 20 }}>
                    <div>
                        <FieldLabel>{t.productCodeLabel}</FieldLabel>
                        <input
                            ref={codeInputRef}
                            value={form.productCode}
                            onChange={e => updateField("productCode", e.target.value)}
                            placeholder={t.productCodePlaceholder}
                            className="pp-input"
                            style={inputStyle(fieldErrors.productCode)}
                        />
                        <FieldError message={fieldErrors.productCode} />
                    </div>

                    <div>
                        <FieldLabel>{t.productNameLabel}</FieldLabel>
                        <input
                            value={form.name}
                            onChange={e => updateField("name", e.target.value)}
                            placeholder={t.namePlaceholder}
                            className="pp-input"
                            style={inputStyle(fieldErrors.name)}
                        />
                        <FieldError message={fieldErrors.name} />
                    </div>

                    <div>
                        <FieldLabel>{t.packingTypeLabel}</FieldLabel>
                        <select
                            value={form.packingType}
                            onChange={e => updateField("packingType", e.target.value)}
                            className="pp-input"
                            style={{ ...inputStyle(false), appearance: "auto", cursor: "pointer" }}
                        >
                            {PACKING_TYPE_OPTIONS.map(opt => (
                                <option key={opt.value} value={opt.value}>
                                    {lang === "ar" ? opt.ar : opt.fa}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <FieldLabel>{t.countOfBoxLabel}</FieldLabel>
                        <input
                            type="number"
                            min={1}
                            step={1}
                            value={form.countOfBox}
                            onChange={e => updateField("countOfBox", e.target.value)}
                            placeholder={t.countOfBoxPlaceholder}
                            className="pp-input"
                            style={inputStyle(fieldErrors.countOfBox)}
                        />
                        <FieldError message={fieldErrors.countOfBox} />
                    </div>
                    <div>
                        <FieldLabel>{t.weightLabel}</FieldLabel>
                        <div style={{ position: "relative" }}>
                            <input
                                type="number"
                                step="0.001"
                                min={0}
                                value={form.weight}
                                onChange={e => updateField("weight", e.target.value)}
                                placeholder={t.weightPlaceholder}
                                className="pp-input"
                                style={{ ...inputStyle(fieldErrors.weight), paddingInlineEnd: 44 }}
                            />
                            <span style={{
                                position: "absolute", insetInlineEnd: 12, top: "50%", transform: "translateY(-50%)",
                                fontSize: 11.5, fontWeight: 600, color: COLORS.muted, pointerEvents: "none",
                            }}>
                                {t.weightUnit}
                            </span>
                        </div>
                        <FieldError message={fieldErrors.weight} />
                    </div>

                    <div
                        onClick={() => updateField("isActive", !form.isActive)}
                        style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            gap: 12, padding: "11px 12px", borderRadius: 10,
                            border: `1.5px solid ${COLORS.hairline}`, background: COLORS.paper,
                            cursor: "pointer", userSelect: "none",
                        }}
                    >
                        <div>
                            <div style={{ fontSize: 12, fontWeight: 600, color: COLORS.ink }}>
                                {t.isActiveLabel}
                            </div>
                            <div style={{ fontSize: 10.5, color: COLORS.muted, marginTop: 2 }}>
                                {t.isActiveHint}
                            </div>
                        </div>
                        {/* سوییچ ساده بدون کتابخانه خارجی */}
                        <span style={{
                            flexShrink: 0, width: 38, height: 22, borderRadius: 999,
                            background: form.isActive ? COLORS.success : COLORS.hairlineStrong,
                            position: "relative", transition: "background 0.15s ease",
                        }}>
                            <span style={{
                                position: "absolute", top: 2,
                                insetInlineStart: form.isActive ? 18 : 2,
                                width: 18, height: 18, borderRadius: "50%", background: "#fff",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                                transition: "inset-inline-start 0.15s ease",
                            }} />
                        </span>
                    </div>
                </div>

                {error && (
                    <div style={{ fontSize: 11.5, color: COLORS.danger, marginBottom: 16, fontWeight: 600 }}>
                        {error}
                    </div>
                )}

                <div style={{ display: "flex", gap: 10 }}>
                    <button onClick={onClose} disabled={loading} style={{
                        flex: 1, padding: "10px 0", borderRadius: 10, border: `1.5px solid ${COLORS.hairlineStrong}`,
                        background: "#fff", color: COLORS.ink, fontWeight: 600, fontSize: 12.5,
                        cursor: loading ? "default" : "pointer", fontFamily: "inherit",
                    }}>
                        {t.cancel}
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="pp-btn-primary"
                        style={{
                            flex: 1, padding: "10px 0", borderRadius: 10, border: "none",
                            background: COLORS.accent,
                            color: "#fff", fontWeight: 700, fontSize: 12.5,
                            cursor: loading ? "default" : "pointer", fontFamily: "inherit",
                            opacity: loading ? 0.85 : 1,
                        }}
                    >
                        {loading ? t.saving : isEdit ? t.saveChanges : t.add}
                    </button>
                </div>
            </div>
        </div>
    );
}

/*
 * مودال ورود اکسل: دو مرحله دارد
 * ۱) دانلود فایل نمونه (با ظاهر رنگی مشابه خروجی اکسل)
 * ۲) انتخاب فایل تکمیل‌شده و شروع فرآیند ورود
 */
function ImportExcelModal({
    open, onClose, onDownloadSample, downloadingSample,
    selectedFile, onSelectFile, onStartImport, importing, t,
}) {
    const fileInputRef = useRef(null);

    if (!open) return null;

    const handlePick = () => fileInputRef.current?.click();

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (file) onSelectFile(file);
    };

    return (
        <div style={{
            position: "fixed", inset: 0, background: "rgba(34,29,58,0.4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 600, padding: 20, overflowY: "auto",
        }}>
            <div onClick={e => e.stopPropagation()} style={{
                background: COLORS.card, borderRadius: 18, padding: 28,
                width: "100%", maxWidth: 460, boxShadow: "0 24px 60px rgba(34,29,58,0.22)",
                fontFamily: FONT_BODY, animation: "pp-pop-in 0.18s ease",
                borderTop: `4px solid ${COLORS.accent}`,
            }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 20 }}>
                    <div>
                        <div style={{
                            fontSize: 16.5, fontWeight: 700, color: COLORS.ink,
                            fontFamily: FONT_DISPLAY,
                        }}>
                            {t.importModalTitle}
                        </div>
                        <div style={{ fontSize: 11.5, color: COLORS.muted, marginTop: 5, lineHeight: 1.8 }}>
                            {t.importModalDesc}
                        </div>
                    </div>
                    <button onClick={onClose} style={{
                        width: 28, height: 28, borderRadius: 8, border: "none",
                        background: COLORS.paper, color: COLORS.muted, fontSize: 12,
                        cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                        flexShrink: 0,
                    }}>✕</button>
                </div>

                {/* مرحله ۱: دانلود فایل نمونه */}
                <div style={{
                    background: COLORS.accentBgSoft, borderRadius: 14,
                    border: `1.5px solid ${COLORS.hairline}`, padding: 16, marginBottom: 14,
                }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: COLORS.ink, marginBottom: 4 }}>
                        {t.downloadSampleTitle}
                    </div>
                    <div style={{ fontSize: 11, color: COLORS.inkSoft, marginBottom: 12, lineHeight: 1.7 }}>
                        {t.downloadSampleDesc}
                    </div>
                    <button
                        onClick={onDownloadSample}
                        disabled={downloadingSample}
                        className="pp-btn-primary"
                        style={{
                            display: "flex", alignItems: "center", gap: 7,
                            background: COLORS.accent, color: "#fff", border: "none",
                            borderRadius: 10, padding: "9px 16px", fontSize: 12, fontWeight: 700,
                            cursor: downloadingSample ? "default" : "pointer", fontFamily: "inherit",
                            opacity: downloadingSample ? 0.7 : 1,
                        }}
                    >
                        <span style={{ fontSize: 13, lineHeight: 1 }}>⇩</span>
                        {downloadingSample ? t.downloadingSample : t.downloadSampleBtn}
                    </button>
                </div>

                {/* مرحله ۲: بارگذاری فایل */}
                <div style={{
                    background: COLORS.paper, borderRadius: 14,
                    border: `1.5px dashed ${COLORS.hairlineStrong}`, padding: 16, marginBottom: 22,
                }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: COLORS.ink, marginBottom: 4 }}>
                        {t.uploadFileTitle}
                    </div>
                    <div style={{ fontSize: 11, color: COLORS.inkSoft, marginBottom: 12, lineHeight: 1.7 }}>
                        {t.uploadFileDesc}
                    </div>

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />

                    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                        <button
                            onClick={handlePick}
                            disabled={importing}
                            style={{
                                display: "flex", alignItems: "center", gap: 7,
                                background: "#fff", color: COLORS.ink,
                                border: `1.5px solid ${COLORS.hairlineStrong}`,
                                borderRadius: 10, padding: "9px 16px", fontSize: 12, fontWeight: 700,
                                cursor: importing ? "default" : "pointer", fontFamily: "inherit",
                            }}
                        >
                            <span style={{ fontSize: 13, lineHeight: 1 }}>📎</span>
                            {selectedFile ? t.changeFileBtn : t.chooseFileBtn}
                        </button>
                        <span style={{
                            fontSize: 11, color: selectedFile ? COLORS.ink : COLORS.muted,
                            fontWeight: selectedFile ? 600 : 400,
                            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 200,
                        }}>
                            {selectedFile ? selectedFile.name : t.noFileChosen}
                        </span>
                    </div>
                </div>

                <div style={{ display: "flex", gap: 10 }}>
                    <button onClick={onClose} disabled={importing} style={{
                        flex: 1, padding: "10px 0", borderRadius: 10, border: `1.5px solid ${COLORS.hairlineStrong}`,
                        background: "#fff", color: COLORS.ink, fontWeight: 600, fontSize: 12.5,
                        cursor: importing ? "default" : "pointer", fontFamily: "inherit",
                    }}>
                        {t.cancel}
                    </button>
                    <button
                        onClick={onStartImport}
                        disabled={importing || !selectedFile}
                        className="pp-btn-primary"
                        style={{
                            flex: 1, padding: "10px 0", borderRadius: 10, border: "none",
                            background: COLORS.accent,
                            color: "#fff", fontWeight: 700, fontSize: 12.5,
                            cursor: (importing || !selectedFile) ? "default" : "pointer", fontFamily: "inherit",
                            opacity: (importing || !selectedFile) ? 0.6 : 1,
                        }}
                    >
                        {importing ? t.importingExcel : t.startImportBtn}
                    </button>
                </div>
            </div>
        </div>
    );
}

function SkeletonRow() {
    return (
        <div style={{
            display: "flex", alignItems: "center", gap: 14,
            padding: "13px 18px", borderBottom: `1px solid ${COLORS.hairline}`,
        }}>
            <div style={{ width: 24, height: 24, borderRadius: 6, background: COLORS.hairline }} />
            <div style={{ width: 64, height: 12, borderRadius: 6, background: COLORS.hairline }} />
            <div style={{ flex: 1, height: 12, borderRadius: 6, background: COLORS.hairline }} />
            <div style={{ width: 80, height: 12, borderRadius: 6, background: COLORS.hairline }} />
            <div style={{ width: 68, height: 24, borderRadius: 8, background: COLORS.hairline }} />
        </div>
    );
}

function SkeletonTile() {
    return (
        <div style={{
            background: COLORS.card, borderRadius: 14, border: `1px solid ${COLORS.hairline}`,
            padding: 16, display: "flex", flexDirection: "column", gap: 12,
        }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: 24, height: 24, borderRadius: 6, background: COLORS.hairline }} />
                <div style={{ width: 54, height: 20, borderRadius: 7, background: COLORS.hairline }} />
            </div>
            <div style={{ height: 12, width: "70%", borderRadius: 6, background: COLORS.hairline }} />
            <div style={{ height: 11, width: "50%", borderRadius: 6, background: COLORS.hairline }} />
        </div>
    );
}

const VIEW_KEY_TABLE = "table";
const VIEW_KEY_GRID = "grid";

function ViewToggle({ view, onChange, t }) {
    return (
        <div style={{
            display: "flex", background: COLORS.paper, borderRadius: 10,
            border: `1.5px solid ${COLORS.hairline}`, padding: 3, gap: 2,
        }}>
            {[
                { key: VIEW_KEY_TABLE, label: t.listView, icon: "☰" },
                { key: VIEW_KEY_GRID, label: t.gridView, icon: "▦" },
            ].map(opt => (
                <button
                    key={opt.key}
                    onClick={() => onChange(opt.key)}
                    className="pp-toggle-btn"
                    style={{
                        display: "flex", alignItems: "center", gap: 5,
                        padding: "7px 12px", borderRadius: 8, border: "none",
                        background: view === opt.key ? COLORS.card : "transparent",
                        color: view === opt.key ? COLORS.ink : COLORS.muted,
                        fontWeight: 600, fontSize: 11.5, cursor: "pointer",
                        fontFamily: FONT_BODY,
                        boxShadow: view === opt.key ? "0 1px 3px rgba(34,29,58,0.1)" : "none",
                    }}
                >
                    <span style={{ fontSize: 11.5 }}>{opt.icon}</span>
                    {opt.label}
                </button>
            ))}
        </div>
    );
}

/*
 * هدر قابل کلیک برای سورت جدول. کلیک اول: صعودی، کلیک دوم روی همون ستون:
 * نزولی، و همینطور به‌صورت متناوب. فلش کوچک جهت فعلی سورت را نشان می‌دهد.
 */
function SortableHeader({ label, sortKey, sortConfig, onSort, style }) {
    const active = sortConfig.key === sortKey;
    return (
        <div
            onClick={() => onSort(sortKey)}
            className="pp-sort-header"
            title={label}
            style={{
                ...style,
                cursor: "pointer",
                userSelect: "none",
                display: "flex",
                alignItems: "center",
                gap: 4,
                color: active ? COLORS.ink : style?.color,
            }}
        >
            {label}
            <span style={{ fontSize: 9, color: active ? COLORS.accent : COLORS.hairlineStrong }}>
                {active ? (sortConfig.direction === "asc" ? "▲" : "▼") : "▲"}
            </span>
        </div>
    );
}

const STATUS_FILTER_ALL = "all";
const STATUS_FILTER_ACTIVE = "active";
const STATUS_FILTER_INACTIVE = "inactive";

/*
 * فیلتر سه‌حالته وضعیت محصول: همه / فعال / غیرفعال.
 * دقیقاً مثل ViewToggle ولی برای فیلتر کردن لیست بر اساس p.isActive.
 */
function StatusFilter({ value, onChange, t }) {
    return (
        <div style={{
            display: "flex", background: COLORS.paper, borderRadius: 10,
            border: `1.5px solid ${COLORS.hairline}`, padding: 3, gap: 2,
        }}>
            {[
                { key: STATUS_FILTER_ALL, label: t.allStatus },
                { key: STATUS_FILTER_ACTIVE, label: t.active },
                { key: STATUS_FILTER_INACTIVE, label: t.inactive },
            ].map(opt => (
                <button
                    key={opt.key}
                    onClick={() => onChange(opt.key)}
                    className="pp-toggle-btn"
                    style={{
                        padding: "7px 12px", borderRadius: 8, border: "none",
                        background: value === opt.key ? COLORS.card : "transparent",
                        color: value === opt.key ? COLORS.ink : COLORS.muted,
                        fontWeight: 600, fontSize: 11.5, cursor: "pointer",
                        fontFamily: FONT_BODY,
                        boxShadow: value === opt.key ? "0 1px 3px rgba(34,29,58,0.1)" : "none",
                        whiteSpace: "nowrap",
                    }}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}

/* بج کوچک رنگی برای نمایش وضعیت فعال/غیرفعال محصول در جدول و کارت */
function StatusBadge({ isActive, t }) {
    const on = !!isActive;
    return (
        <span style={{
            display: "inline-flex", alignItems: "center", gap: 5,
            padding: "3px 9px", borderRadius: 999,
            fontSize: 10.5, fontWeight: 700,
            background: on ? COLORS.successBg : COLORS.dangerBg,
            color: on ? COLORS.success : COLORS.danger,
            border: `1px solid ${on ? "#BFE0CC" : COLORS.dangerBorder}`,
            whiteSpace: "nowrap",
        }}>
            <span style={{
                width: 6, height: 6, borderRadius: "50%",
                background: on ? COLORS.success : COLORS.danger,
            }} />
            {on ? t.active : t.inactive}
        </span>
    );
}

function packingTypeLabel(value, lang) {
    const opt = PACKING_TYPE_OPTIONS.find(o => o.value === value);
    if (!opt) return "—";
    return lang === "ar" ? opt.ar : opt.fa;
}

export default function ProductPage() {
    const { lang } = useLanguage();
    const t = TEXTS[lang] || TEXTS.fa;

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState("");
    const [search, setSearch] = useState("");
    const [view, setView] = useState(VIEW_KEY_TABLE);
    // فیلتر نمایش بر اساس وضعیت فعال/غیرفعال محصول
    const [statusFilter, setStatusFilter] = useState(STATUS_FILTER_ALL);
    // شناسه محصولی که در حال حاضر وضعیتش (فعال/غیرفعال) در حال تغییر است
    const [toggleLoadingId, setToggleLoadingId] = useState(null);

    // سورت جدول: کلید ستون فعال و جهت (asc/desc)
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    // صفحه‌بندی (pagination)
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("add");
    const [activeProduct, setActiveProduct] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitError, setSubmitError] = useState("");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    // فلگ جدید: وقتی بک‌اند اعلام کند محصول در جدول Grouping زیرمجموعه فعال دارد
    const [needsForceConfirm, setNeedsForceConfirm] = useState(false);

    const [toast, setToast] = useState(null);

    // اکسل: خروجی / ورودی
    const [exporting, setExporting] = useState(false);
    const [importing, setImporting] = useState(false);
    const [downloadingSample, setDownloadingSample] = useState(false);
    const [importModalOpen, setImportModalOpen] = useState(false);
    const [importFile, setImportFile] = useState(null);

    // ✅ اصلاح‌شده
    const fetchProducts = async () => {
        setLoading(true);
        setLoadError("");
        try {
            const res = await GetAllProduct();
            setProducts(res?.data ?? []);
        } catch (err) {
            setLoadError(getServerErrorMessage(err, t.loadError));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openAddModal = () => {
        setModalMode("add");
        setActiveProduct(null);
        setSubmitError("");
        setModalOpen(true);
    };

    const openEditModal = (product) => {
        setModalMode("edit");
        setActiveProduct(product);
        setSubmitError("");
        setModalOpen(true);
    };

    const closeModal = () => {
        if (submitLoading) return;
        setModalOpen(false);
    };

    const handleSubmit = async (values) => {
        setSubmitLoading(true);
        setSubmitError("");
        try {
            if (modalMode === "edit") {
                await UpdateProduct({ id: activeProduct.id, ...values });
                setToast({ type: "success", message: t.productEdited });
            } else {
                await AddProduct({ ...values });
                setToast({ type: "success", message: t.productAdded });
            }
            setModalOpen(false);
            fetchProducts();
        } catch (err) {
            // پیام واقعی سرویس (مثلاً «کد محصول قبلاً ثبت شده است.») را نشان می‌دهیم،
            // نه فقط پیام عمومی — هم در حالت افزودن و هم ویرایش.
            setSubmitError(getServerErrorMessage(err, t.saveFailed));
        } finally {
            setSubmitLoading(false);
        }
    };

    /*
     * تغییر سریع وضعیت فعال/غیرفعال بدون باز کردن مودال ویرایش.
     * کل آبجکت محصول را با isActive معکوس‌شده به UpdateProduct می‌فرستیم،
     * چون سرویس UpdateProduct کل ProductViewModel را می‌خواهد.
     */
    const toggleActive = async (product) => {
        setToggleLoadingId(product.id);
        try {
            await UpdateProduct({ ...product, isActive: !product.isActive });
            setToast({
                type: "success",
                message: product.isActive ? t.productDeactivated : t.productActivated,
            });
            fetchProducts();
        } catch (err) {
            setToast({ type: "error", message: getServerErrorMessage(err, t.statusChangeFailed) });
        } finally {
            setToggleLoadingId(null);
        }
    };

    const askDelete = (product) => {
        setDeleteTarget(product);
        setNeedsForceConfirm(false); // همیشه با حالت عادی (بدون هشدار) شروع می‌کنیم
        setConfirmOpen(true);
    };

    const cancelDelete = () => {
        if (deleteLoading) return;
        setConfirmOpen(false);
        setDeleteTarget(null);
        setNeedsForceConfirm(false);
    };

    /*
     * منطق حذف:
     * 1) بار اول بدون confirmDelete درخواست می‌فرستیم.
     * 2) اگر بک‌اند بگوید محصول دارای زیرمجموعه فعال است (requiresConfirmation)،
     *    به‌جای بستن دیالوگ یا نمایش خطا، همان دیالوگ را با پیام هشدار نگه می‌داریم
     *    تا کاربر دوباره تایید کند.
     * 3) در تایید دوم، confirmDelete=true ارسال می‌شود تا گروپینگ و زیرشاخه‌هایش هم حذف شوند.
     */
    const confirmDelete = async () => {
        setDeleteLoading(true);
        try {
            await RemoveProduct(deleteTarget.id, needsForceConfirm);
            setToast({ type: "success", message: t.productDeleted });
            setConfirmOpen(false);
            setDeleteTarget(null);
            setNeedsForceConfirm(false);
            fetchProducts();
        } catch (err) {
            const requiresConfirmation = err?.response?.data?.requiresConfirmation;
            if (requiresConfirmation && !needsForceConfirm) {
                // دیالوگ باز می‌ماند؛ فقط پیام و ظاهر آن به حالت هشدار تغییر می‌کند
                setNeedsForceConfirm(true);
            } else {
                // اگر بک‌اند پیام مشخصی برگردانده باشد (مثلاً «این کالا در
                // سفارش‌ها استفاده شده و قابل حذف نیست.») همان نشان داده می‌شود،
                // در غیر این صورت پیام عمومی deleteFailed.
                setToast({ type: "error", message: getServerErrorMessage(err, t.deleteFailed) });
                setConfirmOpen(false);
                setDeleteTarget(null);
                setNeedsForceConfirm(false);
            }
        } finally {
            setDeleteLoading(false);
        }
    };

    const filtered = useMemo(
        () => products.filter(p => {
            if (statusFilter === STATUS_FILTER_ACTIVE && !p.isActive) return false;
            if (statusFilter === STATUS_FILTER_INACTIVE && p.isActive) return false;

            const q = search.trim().toLowerCase();
            if (!q) return true;

            // جستجو روی تمام ستون‌های قابل‌نمایش جدول
            const haystack = [
                p.name,
                p.productCode,
                packingTypeLabel(p.packingType, lang),
                p.countOfBox,
                p.weight,
                p.isActive ? t.active : t.inactive,
            ]
                .map(v => (v === null || v === undefined ? "" : String(v)))
                .join(" \u0000 ")
                .toLowerCase();

            return haystack.includes(q);
        }),
        [products, search, statusFilter, lang, t]
    );

    // با هر تغییر در جستجو / فیلتر وضعیت / نما، به صفحه اول برگرد
    useEffect(() => {
        setPage(1);
    }, [search, statusFilter, view, pageSize]);

    // کلیک روی هر ستون سورت را روی همان کلید فعال می‌کند؛ کلیک دوباره جهت را برعکس می‌کند.
    const handleSort = (key) => {
        setSortConfig(prev =>
            prev.key === key
                ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
                : { key, direction: "asc" }
        );
    };

    // لیست نهایی برای نمایش: فیلترشده + سورت‌شده طبق ستون انتخابی
    const sortedFiltered = useMemo(() => {
        if (!sortConfig.key) return filtered;
        const dir = sortConfig.direction === "asc" ? 1 : -1;
        const arr = [...filtered];

        arr.sort((a, b) => {
            switch (sortConfig.key) {
                case "productCode":
                    return (a.productCode ?? "").localeCompare(b.productCode ?? "", lang) * dir;
                case "name":
                    return (a.name ?? "").localeCompare(b.name ?? "", lang) * dir;
                case "packingType":
                    return packingTypeLabel(a.packingType, lang)
                        .localeCompare(packingTypeLabel(b.packingType, lang), lang) * dir;
                case "countOfBox":
                    return ((Number(a.countOfBox) || 0) - (Number(b.countOfBox) || 0)) * dir;
                case "weight":
                    return ((Number(a.weight) || 0) - (Number(b.weight) || 0)) * dir;
                case "isActive":
                    return ((a.isActive ? 1 : 0) - (b.isActive ? 1 : 0)) * dir;
                default:
                    return 0;
            }
        });

        return arr;
    }, [filtered, sortConfig, lang]);

    // ---- صفحه‌بندی: تکه‌ی مربوط به صفحه‌ی جاری از لیست نهایی ----
    const totalItems = sortedFiltered.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    const safePage = Math.min(page, totalPages);

    useEffect(() => {
        if (page !== safePage) setPage(safePage);
    }, [safePage]); // eslint-disable-line react-hooks/exhaustive-deps

    const pageStartIndex = (safePage - 1) * pageSize;
    const paginated = useMemo(
        () => sortedFiltered.slice(pageStartIndex, pageStartIndex + pageSize),
        [sortedFiltered, pageStartIndex, pageSize]
    );

    // ---- خروجی اکسل با ظاهر رنگی ----
    const handleExportExcel = async () => {
        if (!filtered.length) {
            setToast({ type: "error", message: t.noDataToExport });
            return;
        }
        setExporting(true);
        try {
            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet(t.products, {
                views: [{ rightToLeft: true, state: "frozen", ySplit: 1 }],
            });

            sheet.columns = [
                // numFmt: "@" یعنی فرمت این ستون «متن» است، پس اکسل صفرهای ابتدایی
                // کد محصول (مثل 050002001) را عدد فرض نمی‌کند و حذفشان نمی‌کند.
                { header: t.code, key: "productCode", width: 18, style: { numFmt: "@" } },
                { header: t.productName, key: "name", width: 32 },
                { header: t.packingType, key: "packingType", width: 16 },
                { header: t.countOfBox, key: "countOfBox", width: 14 },
                { header: `${t.weight} (${t.weightUnit})`, key: "weight", width: 16 },
            ];

            sheet.getColumn("productCode").numFmt = "@";

            const headerRow = sheet.getRow(1);
            headerRow.height = 28;
            headerRow.eachCell(cell => {
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF7C3AED" } };
                cell.font = { color: { argb: "FFFFFFFF" }, bold: true, size: 12, name: "Calibri" };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = {
                    top: { style: "thin", color: { argb: "FF5B21B6" } },
                    bottom: { style: "thin", color: { argb: "FF5B21B6" } },
                    left: { style: "thin", color: { argb: "FF5B21B6" } },
                    right: { style: "thin", color: { argb: "FF5B21B6" } },
                };
            });

            filtered.forEach((p, idx) => {
                const row = sheet.addRow({
                    // به‌صراحت رشته می‌سازیم تا ExcelJS آن را عدد تشخیص ندهد
                    productCode: String(p.productCode ?? ""),
                    name: p.name,
                    packingType: packingTypeLabel(p.packingType, lang),
                    countOfBox: p.countOfBox,
                    weight: p.weight,
                });
                row.height = 22;
                // دوباره روی خودِ سلول هم فرمت متنی را تضمین می‌کنیم
                row.getCell("productCode").numFmt = "@";
                const bg = idx % 2 === 0 ? "FFFBFAFD" : "FFF0E9FB";
                row.eachCell(cell => {
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
                    cell.alignment = { horizontal: "center", vertical: "middle" };
                    cell.font = { name: "Calibri", size: 11, color: { argb: "FF221D3A" } };
                    cell.border = {
                        top: { style: "thin", color: { argb: "FFE8E4F3" } },
                        bottom: { style: "thin", color: { argb: "FFE8E4F3" } },
                        left: { style: "thin", color: { argb: "FFE8E4F3" } },
                        right: { style: "thin", color: { argb: "FFE8E4F3" } },
                    };
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${t.products}-${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (err) {
            setToast({ type: "error", message: t.importFailed });
        } finally {
            setExporting(false);
        }
    };

    // ---- دانلود فایل نمونه اکسل (فقط هدر ستون‌ها، بدون داده) ----
    const handleDownloadSample = async () => {
        setDownloadingSample(true);
        try {
            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet(t.products, {
                views: [{ rightToLeft: true }],
            });

            sheet.columns = [
                // فرمت متنی روی کل ستون؛ چون فایل نمونه بدون داده است، این باعث
                // می‌شود هر کدی که کاربر بعداً در اکسل تایپ کند (حتی با صفر
                // ابتدایی) به‌صورت متن ذخیره شود و اکسل آن را عدد فرض نکند.
                { header: t.code, key: "productCode", width: 18, style: { numFmt: "@" } },
                { header: t.productName, key: "name", width: 32 },
                { header: t.packingType, key: "packingType", width: 16 },
                { header: t.countOfBox, key: "countOfBox", width: 14 },
                { header: `${t.weight} (${t.weightUnit})`, key: "weight", width: 16 },
            ];

            // اطمینان مضاعف: فرمت متنی را روی کل ستون A (نه فقط هدر) هم اعمال می‌کنیم
            sheet.getColumn("productCode").numFmt = "@";

            // دراپ‌دان برای ستون «نوع بسته‌بندی»: فقط مقادیر شیرینگ/کارتن/عدد
            // (بر اساس زبان جاری) قابل انتخاب هستند. این Data Validation از نوع
            // "list" روی محدوده‌ای از ردیف‌ها (۲ تا ۵۰۰) اعمال می‌شود تا کاربر
            // در اکسل به‌جای تایپ آزاد، از یک دراپ‌دان انتخاب کند.
            const packingTypeOptionLabels = PACKING_TYPE_OPTIONS
                .map(opt => (lang === "ar" ? opt.ar : opt.fa))
                .join(",");
            const PACKING_TYPE_SAMPLE_ROWS = 500;
            for (let rowNumber = 2; rowNumber <= PACKING_TYPE_SAMPLE_ROWS; rowNumber++) {
                sheet.getCell(`C${rowNumber}`).dataValidation = {
                    type: "list",
                    allowBlank: true,
                    formulae: [`"${packingTypeOptionLabels}"`],
                    showErrorMessage: true,
                    errorStyle: "stop",
                    errorTitle: lang === "ar" ? "قيمة غير صالحة" : "مقدار نامعتبر",
                    error: lang === "ar"
                        ? "الرجاء اختيار قيمة من القائمة."
                        : "لطفاً یکی از مقادیر شیرینگ، کارتن یا عدد را از لیست انتخاب کنید.",
                    showInputMessage: true,
                    promptTitle: t.packingType,
                    prompt: lang === "ar"
                        ? "اختر نوع التعبئة من القائمة"
                        : "نوع بسته‌بندی را از لیست انتخاب کنید",
                };
            }

            const headerRow = sheet.getRow(1);
            headerRow.height = 28;
            headerRow.eachCell(cell => {
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF7C3AED" } };
                cell.font = { color: { argb: "FFFFFFFF" }, bold: true, size: 12, name: "Calibri" };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = {
                    top: { style: "thin", color: { argb: "FF5B21B6" } },
                    bottom: { style: "thin", color: { argb: "FF5B21B6" } },
                    left: { style: "thin", color: { argb: "FF5B21B6" } },
                    right: { style: "thin", color: { argb: "FF5B21B6" } },
                };
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${t.sampleFileName}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (err) {
            setToast({ type: "error", message: t.importFailed });
        } finally {
            setDownloadingSample(false);
        }
    };

    // ---- ورودی اکسل ----
    const openImportModal = () => {
        setImportFile(null);
        setImportModalOpen(true);
    };

    const closeImportModal = () => {
        if (importing) return;
        setImportModalOpen(false);
        setImportFile(null);
    };

    const handleStartImport = async () => {
        const file = importFile;
        if (!file) return;

        setImporting(true);
        try {
            const workbook = new ExcelJS.Workbook();
            const buffer = await file.arrayBuffer();
            await workbook.xlsx.load(buffer);
            const sheet = workbook.worksheets[0];

            if (!sheet) {
                setToast({ type: "error", message: t.importEmptyFile });
                return;
            }

            const rows = [];
            sheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return; // رد کردن هدر
                const values = row.values; // آرایه با ایندکس از ۱
                const productCode = values[1]?.toString().trim();
                const name = values[2]?.toString().trim();
                const packingLabel = values[3]?.toString().trim();
                const countOfBox = Number(values[4]);
                const weight = Number(values[5]);

                if (!productCode && !name) return;

                const packingOpt = PACKING_TYPE_OPTIONS.find(
                    o => o.fa === packingLabel || o.ar === packingLabel || o.value === Number(packingLabel)
                );

                rows.push({
                    productCode: productCode || "",
                    name: name || "",
                    packingType: packingOpt?.value ?? PACKING_TYPE_OPTIONS[0].value,
                    countOfBox: Number.isFinite(countOfBox) ? countOfBox : 0,
                    weight: Number.isFinite(weight) ? weight : 0,
                });
            });

            if (!rows.length) {
                setToast({ type: "error", message: t.importEmptyFile });
                return;
            }

            // کدهای محصولی که از قبل در سیستم ثبت شده‌اند
            const existingCodes = new Set(
                products.map(p => (p.productCode ?? "").trim().toLowerCase()).filter(Boolean)
            );
            // کدهایی که تا این لحظه از همین فایل با موفقیت اضافه شده‌اند (برای تشخیص تکراری داخل خودِ فایل)
            const seenInFileCodes = new Set();

            let success = 0;
            let fail = 0;
            let duplicateFail = 0;
            const failMessages = [];

            for (const row of rows) {
                const codeNormalized = row.productCode.trim().toLowerCase();
                const isDuplicate =
                    codeNormalized &&
                    (existingCodes.has(codeNormalized) || seenInFileCodes.has(codeNormalized));

                if (isDuplicate) {
                    fail++;
                    duplicateFail++;
                    failMessages.push(
                        t.importDuplicateRow.replace("{name}", row.name || row.productCode)
                    );
                    continue;
                }
                for (const row of rows) {
                    const codeNormalized = row.productCode.trim().toLowerCase();
                    const isDuplicate =
                        codeNormalized &&
                        (existingCodes.has(codeNormalized) || seenInFileCodes.has(codeNormalized));

                    if (isDuplicate) {
                        fail++;
                        duplicateFail++;
                        failMessages.push(
                            t.importDuplicateRow.replace("{name}", row.name || row.productCode)
                        );
                        continue;
                    }

                    // ---- فیلتر جدید: رد کردن محصول با وزن صفر یا نامعتبر ----
                    if (!row.weight || row.weight <= 0) {
                        fail++;
                        failMessages.push(
                            t.importInvalidWeight.replace("{name}", row.name || row.productCode)
                        );
                        continue;
                    }

                    try {
                        await AddProduct(row);
                        success++;
                        if (codeNormalized) seenInFileCodes.add(codeNormalized);
                    } catch (err) {
                        fail++;
                        const reason = getServerErrorMessage(err, t.saveFailed);
                        failMessages.push(
                            t.importGenericRowFail
                                .replace("{name}", row.name || row.productCode)
                                .replace("{reason}", reason)
                        );
                    }
                }
                try {
                    await AddProduct(row);
                    success++;
                    if (codeNormalized) seenInFileCodes.add(codeNormalized);
                } catch (err) {
                    fail++;
                    const reason = getServerErrorMessage(err, t.saveFailed);
                    failMessages.push(
                        t.importGenericRowFail
                            .replace("{name}", row.name || row.productCode)
                            .replace("{reason}", reason)
                    );
                }
            }

            let toastType = "success";
            let toastMessage = t.importSuccess.replace("{count}", success);

            if (fail > 0) {
                toastType = success === 0 ? "error" : "warning";
                const list = failMessages.map(m => `• ${m}`).join("\n");

                toastMessage =
                    success === 0 && duplicateFail === fail
                        ? `${t.importAllFailedDuplicate.replace("{fail}", fail)}\n${list}`
                        : `${t.importPartial.replace("{success}", success).replace("{fail}", fail)}\n${list}`;
            }

            setToast({
                type: toastType,
                message: toastMessage,
                duration: fail > 0 ? null : 2800,
            });
            setImportModalOpen(false);
            setImportFile(null);
            fetchProducts();
        } catch (err) {
            setToast({ type: "error", message: t.importFailed });
        } finally {
            setImporting(false);
        }
    };

    return (
        <div style={{
            background: COLORS.bg, height: "100vh", maxHeight: "100vh", direction: t.dir,
            display: "flex", flexDirection: "column", overflow: "hidden",
            boxSizing: "border-box",
        }}>
            <FontLoader />
            <div style={{
                width: "100%", boxSizing: "border-box",
                fontFamily: FONT_BODY, animation: "pp-fade-in 0.3s ease",
                display: "flex", flexDirection: "column",
                flex: 1, minHeight: 0,
            }}>

                {/* ---- Box 1 : gradient header, title + subtitle + actions ---- */}
                <div className="pp-header-box" style={{
                    position: "relative", overflow: "hidden",
                    background: `linear-gradient(135deg, ${COLORS.gradientFrom} 0%, ${COLORS.gradientVia} 55%, ${COLORS.gradientTo} 100%)`,
                    borderRadius: 0,
                    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
                    flexWrap: "wrap", gap: 14,
                    boxShadow: "0 14px 34px rgba(109,40,217,0.28)",
                }}>
                    <div style={{
                        position: "absolute", top: -40, insetInlineEnd: -30,
                        width: 150, height: 150, borderRadius: "50%",
                        background: "rgba(255,255,255,0.12)", pointerEvents: "none",
                    }} />
                    <div style={{
                        position: "absolute", top: 30, insetInlineEnd: 90,
                        width: 60, height: 60, borderRadius: "50%",
                        background: "rgba(255,255,255,0.10)", pointerEvents: "none",
                    }} />

                    <div style={{ position: "relative", zIndex: 1 }}>
                        <div style={{
                            fontSize: 20, fontWeight: 700, color: "#fff",
                            fontFamily: FONT_DISPLAY,
                        }}>
                            {t.products}
                        </div>
                        <div style={{ fontSize: 12, color: COLORS.gradientText, marginTop: 5 }}>
                            {t.manageSub}
                        </div>
                    </div>

                    <div className="pp-header-actions" style={{ position: "relative", zIndex: 1, display: "flex", flexWrap: "wrap" }}>
                        <button onClick={openImportModal} disabled={importing} className="pp-header-btn" style={{
                            display: "flex", alignItems: "center",
                            background: "rgba(255,255,255,0.18)", color: "#fff",
                            border: "1px solid rgba(255,255,255,0.38)",
                            borderRadius: 10, fontWeight: 700,
                            cursor: importing ? "default" : "pointer", fontFamily: "inherit",
                            opacity: importing ? 0.7 : 1, whiteSpace: "nowrap",
                        }}>
                            <span className="pp-header-btn-icon" style={{ fontSize: 13, lineHeight: 1 }}>⇧</span>
                            <span className="pp-header-btn-label">{importing ? t.importingExcel : t.importExcel}</span>
                        </button>
                        <button onClick={handleExportExcel} disabled={exporting} className="pp-header-btn" style={{
                            display: "flex", alignItems: "center",
                            background: "rgba(255,255,255,0.18)", color: "#fff",
                            border: "1px solid rgba(255,255,255,0.38)",
                            borderRadius: 10, fontWeight: 700,
                            cursor: exporting ? "default" : "pointer", fontFamily: "inherit",
                            opacity: exporting ? 0.7 : 1, whiteSpace: "nowrap",
                        }}>
                            <span className="pp-header-btn-icon" style={{ fontSize: 13, lineHeight: 1 }}>⇩</span>
                            <span className="pp-header-btn-label">{exporting ? t.exportingExcel : t.exportExcel}</span>
                        </button>
                        <button onClick={openAddModal} className="pp-header-btn" style={{
                            display: "flex", alignItems: "center",
                            background: "rgba(255,255,255,0.18)", color: "#fff",
                            border: "1px solid rgba(255,255,255,0.38)",
                            borderRadius: 10, fontWeight: 700,
                            cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
                        }}>
                            <span className="pp-header-btn-icon" style={{ fontSize: 14, lineHeight: 1 }}>+</span>
                            <span className="pp-header-btn-label">{t.newProduct}</span>
                        </button>
                    </div>
                </div>

                {/* ---- Box 2 : search + view toggle, sitting between the two boxes ---- */}
                <div className="pp-search-box" style={{
                    position: "relative", zIndex: 2,
                    background: COLORS.card, borderRadius: 14, border: `1px solid ${COLORS.hairline}`,
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    gap: 12, flexWrap: "wrap",
                    boxShadow: "0 14px 30px rgba(34,29,58,0.14)",
                }}>
                    <div style={{ position: "relative", maxWidth: 360, flex: 1, minWidth: 220 }}>
                        <span style={{
                            position: "absolute", insetInlineEnd: 12, top: "50%", transform: "translateY(-50%)",
                            color: COLORS.muted, fontSize: 12, pointerEvents: "none",
                        }}>⌕</span>
                        <input
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder={t.searchPlaceholder}
                            className="pp-input"
                            style={{
                                width: "100%", padding: "9px 32px 9px 12px",
                                borderRadius: 10, boxSizing: "border-box",
                                border: `1.5px solid ${COLORS.hairline}`, fontSize: 12.5,
                                fontFamily: "inherit", color: COLORS.ink, outline: "none", background: COLORS.paper,
                            }}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                        <StatusFilter value={statusFilter} onChange={setStatusFilter} t={t} />
                        <ViewToggle view={view} onChange={setView} t={t} />
                    </div>
                </div>

                {/* ---- Box 3 : the actual product list / grid content ---- */}
                <div className="pp-content-box" style={{
                    position: "relative", zIndex: 1,
                    display: "flex", flexDirection: "column",
                    flex: 1, minHeight: 0, paddingBottom: 22,
                }}>
                    {!loading && loadError && (
                        <div style={{
                            background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.hairline}`,
                            padding: "48px 20px", textAlign: "center",
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: 11, background: COLORS.dangerBg,
                                color: COLORS.danger, fontSize: 16, fontWeight: 700,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                margin: "0 auto 12px",
                            }}>!</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.ink, marginBottom: 5, fontFamily: FONT_DISPLAY }}>
                                {t.somethingWrong}
                            </div>
                            <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 18 }}>
                                {loadError}
                            </div>
                            <button onClick={fetchProducts} className="pp-btn-primary" style={{
                                background: COLORS.accentBgSoft, color: COLORS.accentDeep, border: "none",
                                borderRadius: 9, padding: "9px 18px", fontSize: 12, fontWeight: 700,
                                cursor: "pointer", fontFamily: "inherit",
                            }}>
                                {t.retry}
                            </button>
                        </div>
                    )}

                    {!loading && !loadError && filtered.length === 0 && (
                        <div style={{
                            background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.hairline}`,
                            padding: "48px 20px", textAlign: "center",
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: 11, background: COLORS.accentBgSoft,
                                color: COLORS.accentDeep, fontSize: 16,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                margin: "0 auto 12px", fontFamily: FONT_MONO, fontWeight: 700,
                            }}>00</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.ink, marginBottom: 5, fontFamily: FONT_DISPLAY }}>
                                {search ? t.noResult : (statusFilter !== STATUS_FILTER_ALL ? t.noResultStatus : t.noProductYet)}
                            </div>
                            <div style={{ fontSize: 12, color: COLORS.muted }}>
                                {search ? t.searchOther : (statusFilter !== STATUS_FILTER_ALL ? "" : t.addFirstProduct)}
                            </div>
                        </div>
                    )}

                    {view === VIEW_KEY_TABLE && (loading || (!loadError && filtered.length > 0)) && (
                        <div className="pp-table-wrap pp-scrollbar" style={{
                            background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.hairline}`,
                            flex: 1, minHeight: 0, overflow: "auto",
                        }}>
                            <div style={{
                                display: "flex", alignItems: "center", gap: 14,
                                padding: "11px 18px", borderBottom: `1.5px solid ${COLORS.hairline}`,
                                background: COLORS.paper, minWidth: 900,
                                position: "sticky", top: 0, zIndex: 2,
                                borderRadius: "16px 16px 0 0",
                            }}>
                                <div style={{ width: 24 }} />
                                <SortableHeader
                                    label={t.code}
                                    sortKey="productCode"
                                    sortConfig={sortConfig}
                                    onSort={handleSort}
                                    style={{ width: 92, fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}
                                />
                                <SortableHeader
                                    label={t.productName}
                                    sortKey="name"
                                    sortConfig={sortConfig}
                                    onSort={handleSort}
                                    style={{ flex: 1, fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}
                                />
                                <SortableHeader
                                    label={t.packingType}
                                    sortKey="packingType"
                                    sortConfig={sortConfig}
                                    onSort={handleSort}
                                    style={{ width: 122, fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}
                                />
                                <SortableHeader
                                    label={t.countOfBox}
                                    sortKey="countOfBox"
                                    sortConfig={sortConfig}
                                    onSort={handleSort}
                                    style={{ width: 84, fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}
                                />
                                <SortableHeader
                                    label={t.weight}
                                    sortKey="weight"
                                    sortConfig={sortConfig}
                                    onSort={handleSort}
                                    style={{ width: 90, fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}
                                />
                                <SortableHeader
                                    label={t.status}
                                    sortKey="isActive"
                                    sortConfig={sortConfig}
                                    onSort={handleSort}
                                    style={{ width: 90, fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}
                                />
                                <div style={{ width: 116, fontSize: 10, fontWeight: 700, color: COLORS.muted, textAlign: "left", textTransform: "uppercase", letterSpacing: "0.04em" }}>{t.actions}</div>
                            </div>

                            {loading && (<><SkeletonRow /><SkeletonRow /><SkeletonRow /><SkeletonRow /></>)}

                            {!loading && paginated.map((p, idx) => (
                                <div key={p.id ?? idx} className="pp-row" style={{
                                    display: "flex", alignItems: "center", gap: 14,
                                    padding: "11px 18px", minWidth: 900,
                                    borderBottom: idx === paginated.length - 1 ? "none" : `1px solid ${COLORS.hairline}`,
                                    background: idx % 2 === 1 ? "#EEF1F7" : "transparent",
                                }}
                                    onMouseEnter={e => e.currentTarget.style.background = COLORS.paper}
                                    onMouseLeave={e => e.currentTarget.style.background = (idx % 2 === 1 ? "#EEF1F7" : "transparent")}
                                >
                                    <div style={{ width: 24 }}><TagStamp index={pageStartIndex + idx} /></div>
                                    <div style={{ width: 92, fontSize: 11.5, color: COLORS.inkSoft, fontFamily: FONT_MONO }}>
                                        {p.productCode || "—"}
                                    </div>
                                    <div style={{ flex: 1, fontSize: 12.5, color: COLORS.ink, fontWeight: 600 }}>
                                        {p.name}
                                    </div>
                                    <div style={{ width: 122, fontSize: 11.5, color: COLORS.inkSoft }}>
                                        {packingTypeLabel(p.packingType, lang)}
                                    </div>
                                    <div style={{ width: 84, fontSize: 11.5, color: COLORS.inkSoft, fontFamily: FONT_MONO }}>
                                        {p.countOfBox ?? "—"}
                                    </div>
                                    <div style={{ width: 90, fontSize: 11.5, color: COLORS.inkSoft, fontFamily: FONT_MONO, }}>
                                        {p.weight ? `${p.weight} ${t.weightUnit}` : "—"}
                                    </div>
                                    <div style={{ width: 90 }}>
                                        <StatusBadge isActive={p.isActive} t={t} />
                                    </div>
                                    <div style={{ width: 116, display: "flex", gap: 6, justifyContent: "flex-start" }}>
                                        <button
                                            onClick={() => toggleActive(p)}
                                            disabled={toggleLoadingId === p.id}
                                            title={p.isActive ? t.deactivate : t.activate}
                                            className="pp-icon-btn"
                                            style={{
                                                width: 28, height: 28, borderRadius: 8,
                                                border: `1.5px solid ${p.isActive ? COLORS.dangerBorder : "#BFE0CC"}`,
                                                background: p.isActive ? COLORS.dangerBg : COLORS.successBg,
                                                cursor: toggleLoadingId === p.id ? "default" : "pointer",
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                color: p.isActive ? COLORS.danger : COLORS.success,
                                                opacity: toggleLoadingId === p.id ? 0.6 : 1,
                                            }}><ToggleActiveIcon isActive={p.isActive} /></button>
                                        <button onClick={() => openEditModal(p)} title={t.edit} className="pp-icon-btn" style={{
                                            width: 28, height: 28, borderRadius: 8, border: `1.5px solid ${COLORS.hairline}`,
                                            background: "#fff", cursor: "pointer", fontSize: 11.5,
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            color: COLORS.inkSoft,
                                        }}>✎</button>
                                        <button onClick={() => askDelete(p)} title={t.delete} className="pp-icon-btn" style={{
                                            width: 28, height: 28, borderRadius: 8, border: `1.5px solid ${COLORS.dangerBorder}`,
                                            background: COLORS.dangerBg, cursor: "pointer", fontSize: 11.5,
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            color: COLORS.danger,
                                        }}>🗑</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {view === VIEW_KEY_GRID && (loading || (!loadError && filtered.length > 0)) && (
                        <div className="pp-scrollbar" style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                        <div style={{
                            display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                            gap: 12,
                        }}>
                            {loading && (<><SkeletonTile /><SkeletonTile /><SkeletonTile /><SkeletonTile /></>)}

                            {!loading && paginated.map((p, idx) => (
                                <div key={p.id ?? idx} className="pp-tile" style={{
                                    background: COLORS.card, borderRadius: 14, border: `1px solid ${COLORS.hairline}`,
                                    padding: 16, display: "flex", flexDirection: "column", gap: 10,
                                }}>
                                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                                        <TagStamp index={pageStartIndex + idx} />
                                        <div style={{ display: "flex", gap: 6 }}>
                                            <button
                                                onClick={() => toggleActive(p)}
                                                disabled={toggleLoadingId === p.id}
                                                title={p.isActive ? t.deactivate : t.activate}
                                                className="pp-icon-btn"
                                                style={{
                                                    width: 26, height: 26, borderRadius: 8,
                                                    border: `1.5px solid ${p.isActive ? COLORS.dangerBorder : "#BFE0CC"}`,
                                                    background: p.isActive ? COLORS.dangerBg : COLORS.successBg,
                                                    cursor: toggleLoadingId === p.id ? "default" : "pointer",
                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                    color: p.isActive ? COLORS.danger : COLORS.success,
                                                    opacity: toggleLoadingId === p.id ? 0.6 : 1,
                                                }}><ToggleActiveIcon isActive={p.isActive} size={13} /></button>
                                            <button onClick={() => openEditModal(p)} title={t.edit} className="pp-icon-btn" style={{
                                                width: 26, height: 26, borderRadius: 8, border: `1.5px solid ${COLORS.hairline}`,
                                                background: "#fff", cursor: "pointer", fontSize: 11,
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                color: COLORS.inkSoft,
                                            }}>✎</button>
                                            <button onClick={() => askDelete(p)} title={t.delete} className="pp-icon-btn" style={{
                                                width: 26, height: 26, borderRadius: 8, border: `1.5px solid ${COLORS.dangerBorder}`,
                                                background: COLORS.dangerBg, cursor: "pointer", fontSize: 11,
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                color: COLORS.danger,
                                            }}>🗑</button>
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                                            <div style={{
                                                fontSize: 13, color: COLORS.ink, fontWeight: 600, lineHeight: 1.5,
                                            }}>
                                                {p.name}
                                            </div>
                                            <StatusBadge isActive={p.isActive} t={t} />
                                        </div>
                                        <div style={{ fontSize: 10.5, color: COLORS.muted, fontFamily: FONT_MONO, marginTop: 3 }}>
                                            {p.productCode || "—"}
                                        </div>
                                    </div>
                                    <div style={{
                                        display: "flex", flexDirection: "column", gap: 4,
                                        paddingTop: 9, borderTop: `1px dashed ${COLORS.hairline}`,
                                        fontSize: 10.5, color: COLORS.inkSoft,
                                    }}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <span style={{ color: COLORS.muted }}>{t.packingType}</span>
                                            <span>{packingTypeLabel(p.packingType, lang)}</span>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <span style={{ color: COLORS.muted }}>{t.countOfBox}</span>
                                            <span style={{ fontFamily: FONT_MONO }}>{p.countOfBox ?? "—"}</span>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <span style={{ color: COLORS.muted }}>{t.weight}</span>
                                            <span style={{ fontFamily: FONT_MONO }}>
                                                {p.weight ? `${p.weight} ${t.weightUnit}` : "—"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        </div>
                    )}

                    {!loading && !loadError && filtered.length > 0 && (
                        <Pagination
                            page={safePage}
                            totalPages={totalPages}
                            totalItems={totalItems}
                            pageSize={pageSize}
                            onPageChange={setPage}
                            onPageSizeChange={setPageSize}
                            t={t}
                            lang={lang}
                        />
                    )}
                </div>
            </div>

            <ProductModal
                open={modalOpen}
                mode={modalMode}
                initialValues={activeProduct}
                onClose={closeModal}
                onSubmit={handleSubmit}
                loading={submitLoading}
                error={submitError}
                lang={lang}
                t={t}
                productsList={products}
                excludeId={modalMode === "edit" ? activeProduct?.id : null}
            />

            <ConfirmDialog
                open={confirmOpen}
                productName={deleteTarget?.name}
                onCancel={cancelDelete}
                onConfirm={confirmDelete}
                loading={deleteLoading}
                needsForceConfirm={needsForceConfirm}
                t={t}
            />

            <ImportExcelModal
                open={importModalOpen}
                onClose={closeImportModal}
                onDownloadSample={handleDownloadSample}
                downloadingSample={downloadingSample}
                selectedFile={importFile}
                onSelectFile={setImportFile}
                onStartImport={handleStartImport}
                importing={importing}
                t={t}
            />

            <Toast toast={toast} onClose={() => setToast(null)} />
        </div>
    );
}